export const INTEGRATION_SOURCES = {
	API: 'API',
	SFTP: 'SFTP'
};

export default INTEGRATION_SOURCES;
